import React from 'react';
import PropTypes from 'prop-types';

const RestrictedPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M8 15v-4.182a8 8 0 0 1 16 0V15h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V17a2 2 0 0 1 2-2h1zm3 0h10v-4.182a5 5 0 0 0-10 0V15z"
    />
  );
};

RestrictedPath.propTypes = {
  fill: PropTypes.string,
};

export default RestrictedPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/permissions/restricted.jsx